import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Dropdown,
  Input,
  Button,
  FormGroup,
  FormField
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardTelepharQueueUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div>
        <div
          id="CardTelepharQueueUX-div-1"
          style={{boxShadow: "none", padding: "10px"}}>
          
          <div
            className="ui form small"
            id="CardTelepharQueueUX-div-2">
            {}
            <FormGroup
              id="CardTelepharQueueUX-FormGroup-115"
              inline={true}>
              <FormField
                id="CardTelepharQueueUX-FormField-116"
                inline={true}>
                <label
                  id="CardTelepharQueueUX-label-135"
                  style={{minWidth:"max-content"}}>
                  {props.languageUX === "en" ? "Name-Surname/HN" : "ชื่อ-สกุล/HN"}
                </label>
              </FormField>
              <FormField
                id="CardTelepharQueueUX-FormField-117"
                inline={true}>
                <div
                  id="CardTelepharQueueUX-div-80"
                  style={{flex:"1"}}>
                  
                  <Input
                    icon="search"
                    id="CardTelepharQueueUX-Input-82"
                    onChange={props.handleChangeValue("selectedPatientSearch")}
                    value={props.selectedPatient}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardTelepharQueueUX-FormField-118"
                inline={true}>
                <label
                  id="CardTelepharQueueUX-label-136"
                  style={{minWidth:"max-content"}}>
                  {props.languageUX === "en" ? "Appointment date" : "วันที่นัดหมาย"}
                </label>
              </FormField>
              <FormField
                id="CardTelepharQueueUX-FormField-119"
                inline={true}>
                <div
                  id="CardTelepharQueueUX-div-61"
                  style={{flex:"1"}}>
                  
                  <DateTextBox
                    id="CardTelepharQueueUX-DateTextBox-62"
                    onChange={props.handleChangeDate("selectedStartDate")}
                    value={props.selectedStartDate}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardTelepharQueueUX-FormField-120"
                inline={true}>
                <label
                  id="CardTelepharQueueUX-label-137">
                  {props.languageUX === "en" ? "to" : "ถึง"}
                </label>
              </FormField>
              <FormField
                id="CardTelepharQueueUX-FormField-121"
                inline={true}>
                <div
                  id="CardTelepharQueueUX-div-78"
                  style={{flex:"1"}}>
                  
                  <DateTextBox
                    id="CardTelepharQueueUX-DateTextBox-79"
                    onChange={props.handleChangeDate("selectedEndDate")}
                    value={props.selectedEndDate}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardTelepharQueueUX-FormField-123"
                inline={true}>
                <label
                  id="CardTelepharQueueUX-label-138"
                  style={{minWidth:"max-content"}}>
                  {props.languageUX === "en" ? "Patient type" : "ประเภทคนไข้"}
                </label>
              </FormField>
              <FormField
                id="CardTelepharQueueUX-FormField-124"
                inline={true}
                width={2}>
                <div
                  id="CardTelepharQueueUX-div-146"
                  style={{flex:"1"}}>
                  
                  <Dropdown
                    id="CardTelepharQueueUX-Dropdown-57"
                    onChange={props.handleChangeValue("selectedPatientType")}
                    options={props.patientOptions}
                    selection={true}
                    value={props.selectedPatientType}>
                  </Dropdown>
                </div>
              </FormField>
              <FormField
                id="CardTelepharQueueUX-FormField-128"
                inline={true}>
                <label
                  id="CardTelepharQueueUX-label-139"
                  style={{minWidth:"max-content"}}>
                  {props.languageUX === "en" ? "Appointment channel" : "ช่องทางการนัด"}
                </label>
              </FormField>
              <FormField
                id="CardTelepharQueueUX-FormField-130"
                inline={true}
                width={2}>
                <div
                  id="CardTelepharQueueUX-div-147"
                  style={{flex:"1"}}>
                  
                  <Dropdown
                    id="CardTelepharQueueUX-Dropdown-56"
                    onChange={props.handleChangeValue("selectedApplicationType")}
                    options={props.applicationOption}
                    selection={true}
                    value={props.selectedApplicationType}>
                  </Dropdown>
                </div>
              </FormField>
              <FormField
                id="CardTelepharQueueUX-FormField-131"
                inline={true}>
                <label
                  id="CardTelepharQueueUX-label-140"
                  style={{minWidth:"max-content"}}>
                  {props.languageUX === "en" ? "Appointment status" : "สถานะการนัด"}
                </label>
              </FormField>
              <FormField
                id="CardTelepharQueueUX-FormField-132"
                inline={true}
                width={2}>
                <div
                  id="CardTelepharQueueUX-div-148"
                  style={{flex:"1"}}>
                  
                  <Dropdown
                    id="CardTelepharQueueUX-Dropdown-55"
                    onChange={props.handleChangeValue("selectedAppointmentStatus")}
                    options={props.appointmentStatusOption}
                    selection={true}
                    value={props.selectedAppointmentStatus}>
                  </Dropdown>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardTelepharQueueUX-FormGroup-141"
              inline={true}>
              <div
                id="CardTelepharQueueUX-div-101"
                style={{flex:"1"}}>
                
              </div>
              <FormField
                id="CardTelepharQueueUX-FormField-143">
                <div
                  id="CardTelepharQueueUX-div-102">
                  
                  <Button
                    color="blue"
                    id="CardTelepharQueueUX-Button-105"
                    loading={props.searchLoading}
                    onClick={props.handleSearchAppointment}>
                    {props.languageUX === "en" ? "Search" : "ค้นหา"}
                  </Button>
                </div>
              </FormField>
              <FormField
                id="CardTelepharQueueUX-FormField-144">
                <div
                  id="CardTelepharQueueUX-div-103"
                  style={{margin:" 0 10px  0 5px"}}>
                  
                  <Button
                    id="CardTelepharQueueUX-Button-106"
                    onClick={props.handleClearData}>
                    {props.languageUX === "en" ? "Clear data" : "ล้างข้อมูล"}
                  </Button>
                </div>
              </FormField>
              <FormField
                id="CardTelepharQueueUX-FormField-145">
                <div
                  id="CardTelepharQueueUX-div-104">
                  
                  <Button
                    color="blue"
                    icon="plus"
                    id="CardTelepharQueueUX-Button-107"
                    onClick={props.addPatient}>
                    {props.childrenButton}
                  </Button>
                </div>
              </FormField>
            </FormGroup>
          </div>
          <div
            id="CardTelepharQueueUX-div-31">
            
            <Table
              data={props.tableItems}
              getTdProps={props.getTdProps}
              getTrProps={props.getTrProps}
              headers="HN,ชื่อ - นามสกุล,ประเภทผู้ป่วย,ช่องทางการนัด,วันที่นัดหมาย,สถานะการนัด"
              id="tb-bilQueueReq"
              keys="hnElement,patientName,patientType,appointmentType,appointmentDateTime,booking"
              minRows="8"
              pageSize="5"
              showPagination={false}
              style={{height: "55vh"}}>
            </Table>
          </div>
          <div
            id="CardTelepharQueueUX-div-36"
            style={{padding: "20px 10px"}}>
            {props.pagination}
          </div>
        </div>
      </div>
    )
}


export default CardTelepharQueueUX

export const screenPropsDefault = {}

/* Date Time : Wed Oct 01 2025 12:11:46 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{boxShadow: \"none\", padding: \"10px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form small"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-div-2"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-div-31"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 32,
      "name": "Table",
      "parent": 31,
      "props": {
        "data": {
          "type": "code",
          "value": "props.tableItems"
        },
        "defaultPageSize": {
          "type": "value",
          "value": ""
        },
        "getTdProps": {
          "type": "code",
          "value": "props.getTdProps"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.getTrProps"
        },
        "headers": {
          "type": "value",
          "value": "HN,ชื่อ - นามสกุล,ประเภทผู้ป่วย,ช่องทางการนัด,วันที่นัดหมาย,สถานะการนัด"
        },
        "id": {
          "type": "value",
          "value": "tb-bilQueueReq"
        },
        "keys": {
          "type": "value",
          "value": "hnElement,patientName,patientType,appointmentType,appointmentDateTime,booking"
        },
        "minRows": {
          "type": "value",
          "value": "8"
        },
        "pageSize": {
          "type": "value",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"55vh\"}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pagination"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-div-36"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"20px 10px\"}"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "Dropdown",
      "parent": 148,
      "props": {
        "clearable": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-Dropdown-55"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"selectedAppointmentStatus\")"
        },
        "options": {
          "type": "code",
          "value": "props.appointmentStatusOption"
        },
        "search": {
          "type": "code",
          "value": ""
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.selectedAppointmentStatus"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "Dropdown",
      "parent": 147,
      "props": {
        "clearable": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-Dropdown-56"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"selectedApplicationType\")"
        },
        "options": {
          "type": "code",
          "value": "props.applicationOption"
        },
        "search": {
          "type": "code",
          "value": ""
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.selectedApplicationType"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "Dropdown",
      "parent": 146,
      "props": {
        "clearable": {
          "type": "code",
          "value": ""
        },
        "defaultValue": {
          "type": "value",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-Dropdown-57"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"selectedPatientType\")"
        },
        "options": {
          "type": "code",
          "value": "props.patientOptions"
        },
        "search": {
          "type": "code",
          "value": ""
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.selectedPatientType"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-div-61"
        },
        "style": {
          "type": "code",
          "value": "{flex:\"1\"}"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 62,
      "name": "DateTextBox",
      "parent": 61,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-DateTextBox-62"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeDate(\"selectedStartDate\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.selectedStartDate"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": null,
      "id": 78,
      "name": "div",
      "parent": 121,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-div-78"
        },
        "style": {
          "type": "code",
          "value": "{flex:\"1\"}"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 79,
      "name": "DateTextBox",
      "parent": 78,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-DateTextBox-79"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeDate(\"selectedEndDate\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.selectedEndDate"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "div",
      "parent": 117,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-div-80"
        },
        "style": {
          "type": "code",
          "value": "{flex:\"1\"}"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 82,
      "name": "Input",
      "parent": 80,
      "props": {
        "icon": {
          "type": "value",
          "value": "search"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-Input-82"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"selectedPatientSearch\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.selectedPatient"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 101,
      "name": "div",
      "parent": 141,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-div-101"
        },
        "style": {
          "type": "code",
          "value": "{flex:\"1\"}"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": null,
      "id": 102,
      "name": "div",
      "parent": 143,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-div-102"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "div",
      "parent": 144,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-div-103"
        },
        "style": {
          "type": "code",
          "value": "{margin:\" 0 10px  0 5px\"}"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "div",
      "parent": 145,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-div-104"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "Button",
      "parent": 102,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-Button-105"
        },
        "loading": {
          "type": "code",
          "value": "props.searchLoading"
        },
        "onClick": {
          "type": "code",
          "value": "props.handleSearchAppointment"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 106,
      "name": "Button",
      "parent": 103,
      "props": {
        "children": {
          "type": "value",
          "value": "ล้างข้อมูล",
          "valueEN": "Clear data"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-Button-106"
        },
        "onClick": {
          "type": "code",
          "value": "props.handleClearData"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 107,
      "name": "Button",
      "parent": 104,
      "props": {
        "children": {
          "type": "code",
          "value": "props.childrenButton"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "icon": {
          "type": "value",
          "value": "plus"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-Button-107"
        },
        "onClick": {
          "type": "code",
          "value": "props.addPatient"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 115,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-FormGroup-115"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 116,
      "name": "FormField",
      "parent": 115,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-FormField-116"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 117,
      "name": "FormField",
      "parent": 115,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-FormField-117"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 118,
      "name": "FormField",
      "parent": 115,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-FormField-118"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 119,
      "name": "FormField",
      "parent": 115,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-FormField-119"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 120,
      "name": "FormField",
      "parent": 115,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-FormField-120"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 121,
      "name": "FormField",
      "parent": 115,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-FormField-121"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 123,
      "name": "FormField",
      "parent": 115,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-FormField-123"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 124,
      "name": "FormField",
      "parent": 115,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-FormField-124"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 128,
      "name": "FormField",
      "parent": 115,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-FormField-128"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 130,
      "name": "FormField",
      "parent": 115,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-FormField-130"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 131,
      "name": "FormField",
      "parent": 115,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-FormField-131"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 132,
      "name": "FormField",
      "parent": 115,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-FormField-132"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": null,
      "id": 135,
      "name": "label",
      "parent": 116,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ-สกุล/HN",
          "valueEN": "Name-Surname/HN"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-label-135"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"max-content\"}"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": null,
      "id": 136,
      "name": "label",
      "parent": 118,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่นัดหมาย",
          "valueEN": "Appointment date"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-label-136"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"max-content\"}"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": null,
      "id": 137,
      "name": "label",
      "parent": 120,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-label-137"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": null,
      "id": 138,
      "name": "label",
      "parent": 123,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทคนไข้",
          "valueEN": "Patient type"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-label-138"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"max-content\"}"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": null,
      "id": 139,
      "name": "label",
      "parent": 128,
      "props": {
        "children": {
          "type": "value",
          "value": "ช่องทางการนัด",
          "valueEN": "Appointment channel"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-label-139"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"max-content\"}"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": null,
      "id": 140,
      "name": "label",
      "parent": 131,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะการนัด",
          "valueEN": "Appointment status"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-label-140"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"max-content\"}"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 141,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-FormGroup-141"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 143,
      "name": "FormField",
      "parent": 141,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-FormField-143"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 144,
      "name": "FormField",
      "parent": 141,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-FormField-144"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 145,
      "name": "FormField",
      "parent": 141,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-FormField-145"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": null,
      "id": 146,
      "name": "div",
      "parent": 124,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-div-146"
        },
        "style": {
          "type": "code",
          "value": "{flex:\"1\"}"
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": null,
      "id": 147,
      "name": "div",
      "parent": 130,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-div-147"
        },
        "style": {
          "type": "code",
          "value": "{flex:\"1\"}"
        }
      },
      "seq": 147,
      "void": false
    },
    {
      "from": null,
      "id": 148,
      "name": "div",
      "parent": 132,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelepharQueueUX-div-148"
        },
        "style": {
          "type": "code",
          "value": "{flex:\"1\"}"
        }
      },
      "seq": 148,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": true,
  "memo": false,
  "name": "CardTelepharQueueUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
